export default __webpack_public_path__ + "97f2b4c2a7f573e4b02f574dd7004d7d.png";